import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Modal, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

const EmailValidationBanner = ({ visible = true, email = "", onClose, onResend }) => {
  const [cooldownRemaining, setCooldownRemaining] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (cooldownRemaining > 0) {
      const timer = setTimeout(() => {
        setCooldownRemaining(cooldownRemaining - 1000);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [cooldownRemaining]);

  const handleResendEmail = async () => {
    if (cooldownRemaining > 0) return;
    
    setLoading(true);
    setCooldownRemaining(60000);
    
    try {
      await onResend();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={visible} onHide={onClose} centered backdrop="static">
      <Modal.Body className="text-center py-5">
        <div className="mb-4">
          <FontAwesomeIcon
            icon={faEnvelope}
            size="3x"
            style={{ color: "#f39c12" }}
          />
        </div>

        <h4 className="mb-3">Valida tu Email</h4>

        <p className="text-muted mb-2">Hemos enviado un email de validación a:</p>
        
        {email && <p className="fw-bold text-primary mb-4">{email}</p>}

        <p className="text-muted mb-4">
          Por favor, revisa tu bandeja de entrada y haz clic en el enlace de validación para activar tu cuenta.
        </p>

        <div className="bg-light p-3 rounded mb-4 text-start">
          <p className="fw-bold mb-2">Consejos:</p>
          <ul className="small mb-0">
            <li>Revisa la carpeta de spam o correo no deseado</li>
            <li>El email puede tardar unos minutos en llegar</li>
            <li>Busca un email de &quot;CEAEmociones&quot;</li>
          </ul>
        </div>

        <p className="small text-muted mb-3">¿No recibiste el email?</p>

        <div className="d-grid gap-2">
          <Button
            variant="warning"
            onClick={handleResendEmail}
            disabled={loading || cooldownRemaining > 0}
          >
            {loading ? "Enviando..." : cooldownRemaining > 0 ? `Espera ${Math.ceil(cooldownRemaining / 1000)}s` : "Reenviar Email"}
          </Button>
        </div>
      </Modal.Body>

      <Modal.Footer className="border-top-0">
        <Button variant="secondary" onClick={onClose}>
          Entendido
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

EmailValidationBanner.propTypes = {
  visible: PropTypes.bool,
  email: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onResend: PropTypes.func.isRequired,
};

export default EmailValidationBanner;
